import Pagination from 'components/data-visualization/Table/Pagination';
import {
  withProps,
  withHandlers,
  branch,
  renderNothing,
  compose,
} from 'recompose';

const hideIfNoData = (hasNoData: any): any => branch(hasNoData, renderNothing);
const hideIfNoResults = (hasNoResults: any): any =>
  branch(hasNoResults, renderNothing);

export default compose<any, any>(
  hideIfNoData((props: { data: any }) => !props.data),
  withProps(
    (props: {
      data: any;
      offset: number;
      isWideButton?: boolean;
      showOnlyTotal?: boolean;
    }) => {
      const { isWideButton, showOnlyTotal } = props;
      const total =
        props.data?.entityData?.playlist_count ||
        props.data?.totalPlaylistCount;
      const current =
        props.data?.entityData?.playlists?.length ||
        props.data?.playlists?.length ||
        0;

      // if the current number of items and the offset are larger than the total number of items,
      // set the offset to the remaining number of requestable items.
      if (current + props.offset > total) {
        return {
          current,
          total,
          isWideButton,
          showOnlyTotal,
          offset: total - current,
          hasMoreResults: current < total,
        };
      }

      return {
        current,
        total,
        isWideButton,
        showOnlyTotal,
        hasMoreResults: current < total,
      };
    }
  ),
  hideIfNoResults((props: { total: number }) => props.total <= 0),
  withHandlers({
    onClick:
      (props: { handleClick: (props: any) => any; offset: number }): any =>
      (): any =>
        props.handleClick(props.offset),
  })
)(Pagination);
